import React from "react";
import { ReactComponent as Fb } from "assets/icons/fbicon.svg";
import { ReactComponent as Insta } from "assets/icons/instaicon.svg";
import { ReactComponent as Linkedin } from "assets/icons/linkedinicon.svg";
import { ReactComponent as Github } from "assets/icons/github.svg";
import { ReactComponent as Gem1 } from "assets/gemstones/gem4.svg";
import { AWS_S3_URL, FIREBASE_STORAGE_URL } from "utils/constants";

function TeamGridItem({ id, image, name, desig, links }) {
  // desgin- designation
  // links- object of links(fb,insta,linkedin,github)
  return (
    <div className="cube-container text-center p-8">
      <div className="photo-cube w-[200px] h-[200px] relative">
        <div className="front w-full h-full flex items-center absolute bg-[rgba(0,0,0,0.9)]">
          <div className="photo-cube-img h-full w-full">
            <img
              src={`${FIREBASE_STORAGE_URL}team-22%2F${
                image.split(".")[0]
              }.jpg?alt=media`}
              className="h-full w-full object-cover"
              alt={name}
              onError={(e) => onImageLoadErrorHandler(e, image)}
            />
          </div>
        </div>
        <div className="back w-full h-full flex items-center flex-col absolute bg-[rgba(0,0,0,0.9)] text-gray-50">
          <p className="p-4 pt-8 font-black-hawk text-xl">
            {id === "C12" ? getSpanFormat(name) : name}
          </p>
          <p className="p-1 px-2 text-red text-md">{desig}</p>
          <div className="flex flex-row justify-evenly p-4 w-full">
            {links.fb && (
              <a href={links.fb} target="_blank" rel="noreferrer">
                {" "}
                <Fb className="h-8 w-8 hover:-translate-y-1 transition-all" />{" "}
              </a>
            )}
            {links.insta && (
              <a href={links.insta} target="_blank" rel="noreferrer">
                {" "}
                <Insta className="h-8 w-8 hover:-translate-y-1 transition-all" />{" "}
              </a>
            )}
            {links.linkedin && (
              <a href={links.linkedin} target="_blank" rel="noreferrer">
                {" "}
                <Linkedin className="h-8 w-8 hover:-translate-y-1 transition-all" />{" "}
              </a>
            )}
            {links.github && (
              <a href={links.github} target="_blank" rel="noreferrer">
                {" "}
                <Github className="h-8 w-8 hover:-translate-y-1 transition-all" />{" "}
              </a>
            )}
          </div>
        </div>
        <div className="left w-full h-full flex items-center justify-center absolute bg-[rgba(0,0,0,0.9)]">
          <Gem1 className="h-full w-full p-4" />
        </div>
        <div className="right w-full h-full flex absolute bg-[rgba(0,0,0,0.9)]"></div>
        <div className="bottom w-full h-full flex absolute bg-[#7f060069] blur-md rounded-[50px]"></div>
      </div>
    </div>
  );
}

export default TeamGridItem;

const getSpanFormat = (name) => {
  return (
    <>
      <span className="pr-3">{name.split(" ")[0]}</span>
      <span>{name.split(" ")[1]}</span>
    </>
  );
};

const onImageLoadErrorHandler = (event, image) => {
  if (event) event.target.src = `${AWS_S3_URL}team-22/${image}`;
};
